(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  // NOTE: Liquid is NOT evaluated inside a section javascript block — Shopify serves
  // these blocks verbatim in compiled_assets/scripts.js. This used to contain a raw
  // Liquid if/endif pair plus one stray closing brace, which made that bundle a syntax
  // error for EVERY page that loads it. Testing for the element does the same job in
  // valid JS: when the discount input setting is off, the field simply is not rendered.
  var couponCodeField = document.getElementById('coupon_code_cart');
  if (couponCodeField) {
    couponCodeField.value = localStorage.getItem('coupon') || '';
  }


  } catch(e) { console.error(e); }
})();
})();
